<script lang="ts">
  import { initDatadog } from '@tomra/datadog-browser-logging'
  import { DATADOG_CONFIG, VERSION, ENV, STAGE } from '$lib/environment'
  import { onMount } from 'svelte'
  import type { Snippet } from 'svelte'
  import '../tailwind.config.css'

  let { children }: { children: Snippet } = $props()

  onMount(() => {
    initDatadog({
      ...DATADOG_CONFIG,
      version: VERSION,
      env: `${ENV}-${STAGE}`
    })
  })
</script>

{@render children()}
